const GET_PRICE = 'publicador/ducks/priceStep/GET_PRICE';
const GET_PRICE_FAILED = 'publicador/ducks/priceStep/GET_PRICE_FAILED';
const GET_PRICE_COMPLETED = 'publicador/ducks/priceStep/GET_PRICE_COMPLETED';
const SET_PRICE_INFO = 'publicador/ducks/priceStep/SET_PRICE_INFO';
const SET_EXPENSES = 'publicador/ducks/priceStep/SET_EXPENSES';

const RESET_INFO = 'publicador/ducks/priceStep/RESET_INFO';

export { GET_PRICE, GET_PRICE_FAILED, GET_PRICE_COMPLETED, SET_PRICE_INFO, SET_EXPENSES, RESET_INFO };
